// extracted by mini-css-extract-plugin
export default {"r_l":"da4559abae ad47c8b788","t":"_494335d93d"};